import { ColumnDef } from '@tanstack/react-table';
import RevealDropdown, {
  RevealDropdownTrigger
} from 'components/base/RevealDropdown';
import { Dropdown } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import LocationModal from 'components/modals/LocationModal';
import { useState } from 'react';
import { Location, DELETE_LOCATION } from 'services/api/location';
import { useQueryClient } from 'react-query';
import { format } from 'date-fns';
import { toast } from 'react-hot-toast';

const handleDelete = async (locationId: string) => {
  try {
    await DELETE_LOCATION(locationId);
    toast.success('Location deleted successfully');
  } catch (error: any) {
    const message =
      error?.response?.data?.message ||
      error?.message ||
      'Error deleting location';
    toast.error(message);
  }
};

export const locationColumns = (
  canEdit = false,
  canDelete = false
): ColumnDef<Location>[] => [
  {
    accessorKey: 'location',
    header: 'Location',
    cell: ({ row: { original } }) => {
      const location = original.location;
      return (
        <div className="d-flex align-items-center">
          <div>
            <Link to="" className="fs-8 fw-bold">
              {location}
            </Link>
          </div>
        </div>
      );
    },
    meta: {
      headerProps: { style: { width: '25%' }, className: 'ps-0' },
      cellProps: { className: 'white-space-nowrap ps-0' }
    }
  },

  {
    accessorKey: 'createdAt',
    header: 'Created At',
    cell: ({ row: { original } }) => {
      return (
        <div className="d-flex align-items-center">
          {format(new Date(original.createdAt), 'MMM dd, yyyy HH:mm')}
        </div>
      );
    },
    meta: {
      headerProps: { style: { width: '20%' } },
      cellProps: { className: 'white-space-nowrap' }
    }
  },

  {
    accessorKey: 'updatedAt',
    header: 'Updated At',
    cell: ({ row: { original } }) => {
      return (
        <div className="d-flex align-items-center">
          {format(new Date(original.updatedAt), 'MMM dd, yyyy HH:mm')}
        </div>
      );
    },
    meta: {
      headerProps: { style: { width: '20%' } },
      cellProps: { className: 'white-space-nowrap' }
    }
  },

  {
    id: 'leadDropdown',
    cell: ({ row: { original } }) => {
      const locationId = (original as any).id || original._id;
      const navigate = useNavigate();
      const queries = useQueryClient();
      const [showModel, setShowModel] = useState(false);

      const handleDeleteClick = async (locationId: string) => {
        try {
          await handleDelete(locationId);
          queries.invalidateQueries('get_all_location');
          navigate('/home/apps/location');
        } catch (error) {
          console.error('Error handling delete:', error);
        }
      };

      if (!canEdit && !canDelete) {
        return null;
      }
      return (
        <>
          <RevealDropdownTrigger>
            <RevealDropdown>
              <>
                {canEdit && (
                  <Dropdown.Item
                    eventKey="2"
                    onClick={() => setShowModel(true)}
                  >
                    Edit
                  </Dropdown.Item>
                )}
                {canDelete && (
                  <>
                    <Dropdown.Divider />
                    <Dropdown.Item
                      eventKey="4"
                      className="text-danger"
                      onClick={() => handleDeleteClick(locationId)}
                    >
                      Delete
                    </Dropdown.Item>
                  </>
                )}
              </>
            </RevealDropdown>
          </RevealDropdownTrigger>

          {showModel && (
            <LocationModal
              show={showModel}
              handleClose={() => setShowModel(false)}
              isEditing
              location={original}
            />
          )}
        </>
      );
    },
    meta: {
      cellProps: {
        className: 'text-end pe-0 ps-4'
      }
    }
  }
];
